import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Nav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const nav = (content && content.nav) || [];
        const limit = content && content.limit ? content.limit : 18;

        return (
            <nav aria-label="全站导航">
                <ul key="nav" className={styles.list_menu}>
                    {nav.slice(0, limit).map((item, index) => (
                        <li key={index}>
                            <a href={item.url} target="_blank" rel="noopener noreferrer">
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
                {nav.length > limit ? (
                    <div key="navMore" className={styles.morehNew}>
                        <div>
                            <button type="button" className={styles.moreBtn}>
                                更多
                            </button>
                            <ul className={styles.more}>
                                {nav.slice(limit).map((item, index) => (
                                    <li key={index}>
                                        <a href={item.url} target="_blank" rel="noopener noreferrer">
                                            {item.title}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ) : null}
            </nav>
        );
    }
}

export default errorBoundary(Nav);
